export const replacePhone = "+7 (3022) 28-45-15";
export const replacePhoneRoute = "Gmb";

const defaultPhone = "+7 (495) 021-00-09";
const defaultPhoneRoutes = ["PlanCommerceSearch", "CommerceFlat"];

export const isReplacedRoute = (routeName) => routeName === replacePhoneRoute;

export function resolvePhone(routeName, fallback = "") {
  if (isReplacedRoute(routeName)) {
    return { number: replacePhone, class: "" };
  }
  if (defaultPhoneRoutes.includes(routeName)) {
    return { number: defaultPhone, class: "" };
  }
  return { number: fallback, class: "comagic_phone" };
}